// import MikeTooltip from '@mike/mike-shared-frontend/mike-tooltip/MikeTooltip'

import React from 'react'
import messages from '../../shared/messages'
import { ReactComponent as Users } from '@mike/mike-shared-frontend/media/icons/Users'
import { ReactComponent as User } from '@mike/mike-shared-frontend/media/icons/User'

import { Tabs } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useIntl } from 'react-intl'
import { useLocation } from 'react-router-dom'
import { LinkTab, ActiveLabel, activeSvgStyle } from '../AppNav'
import { ReactComponent as Apps } from '@mike/mike-shared-frontend/media/icons/Apps'

const StyledTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: '1px solid' + theme.palette.grey[300],
  paddingLeft: '30px',
  '& .MuiTabs-indicator': {
    height: 3
  }
}))

const UsersNav = () => {
  const intl = useIntl()

  function usePath() {
    return useLocation().pathname
  }

  const currentPath = usePath()

  // Tabs are keyed by name; `false` is MUI's "no tab selected", used for any
  // other path so the indicator isn't parked on an unrelated tab.
  let activeTab: 'users' | 'api' | 'applications' | false

  switch (currentPath) {
    case '/site-access/users':
    case '/site-access':
      activeTab = 'users'
      break
    case '/site-access/api':
      activeTab = 'api'
      break
    case '/site-access/applications':
      activeTab = 'applications'
      break
    default:
      activeTab = false
  }

  return (
    <StyledTabs
      value={activeTab}
      indicatorColor="secondary"
      textColor="primary"
    >
      <LinkTab
        value="users"
        to={'/site-access/users'}
        label={
          activeTab === 'users' ? (
            <ActiveLabel>
              {intl.formatMessage(messages.tenantUsers)}
            </ActiveLabel>
          ) : (
            <span>{intl.formatMessage(messages.tenantUsers)}</span>
          )
        }
        icon={
          <Users style={activeTab === 'users' ? activeSvgStyle : undefined} />
        }
      />
      <LinkTab
        value="api"
        to={'/site-access/api'}
        label={
          activeTab === 'api' ? (
            <ActiveLabel>
              {intl.formatMessage(messages.tenantApiAccess)}
            </ActiveLabel>
          ) : (
            <span>{intl.formatMessage(messages.tenantApiAccess)}</span>
          )
        }
        icon={<User style={activeTab === 'api' ? activeSvgStyle : undefined} />}
      />
      <LinkTab
        value="applications"
        to={'/site-access/applications'}
        label={
          activeTab === 'applications' ? (
            <ActiveLabel>
              {intl.formatMessage(messages.tenantApplications)}
            </ActiveLabel>
          ) : (
            <span>{intl.formatMessage(messages.tenantApplications)}</span>
          )
        }
        icon={
          <Apps
            style={activeTab === 'applications' ? activeSvgStyle : undefined}
          />
        }
      />
    </StyledTabs>
  )
}

export default UsersNav
